import { render, staticRenderFns } from "./AddressForm.html?vue&type=template&id=773ad88e&external"
import script from "./AddressForm.ts?vue&type=script&lang=ts&external"
export * from "./AddressForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports